<div class="line-separator {{getSeparatorStyle}} {{getSeparatorColor}}"></div>